import React from 'react';
import { Card, Space, Button } from 'antd';
import moment from 'moment';
import {
  StyledParagraph, StyledText, StyledTitle,
} from '../CustomAntdComponents/Typography';
import {
  BillingDetailsWrapper,
  DetailsWrapper,
  HighlightDetailItem,
  TitleWrapper,
} from './styles';
import {
  SpaceBetweenAlignContent,
  VerticalAlignContent,
} from '../CustomAntdComponents/Utitlities';
import { ReactComponent as ClockIcon } from '../../assets/images/clock.svg';
import { formatNumberAsCurrency, pluralizeText } from '../../utils/helpers';
import {
  calculateTotalFare, getBoatTransportLogo,
} from '../AvailableBoats/helper';
import { useWaterSearchStore } from '../../store/waterSearch/waterSearchStore';
import WaterTripSummary from '../TripSummary/WaterTripSummary';
import { useI18nContext } from '../../utils/I18n';
import translations from '../../screens/SearchWaterListings/translations';

type Props = {
  showSubmitButton?: boolean,
}
function BoatItinerary({ showSubmitButton }: Props) {
  const {
    state: { t },
  } = useI18nContext();
  const {
    selectedBoat,
    selectedResult,
    formData,
  } = useWaterSearchStore();

  const oneWayTrip = formData.TripType === 'one_way';
  const totalFare = calculateTotalFare(selectedBoat ? selectedBoat.PassengerFares : []);

  const renderTripDetails = (returning = false) => ((selectedResult && selectedBoat) ? (
    <>
      <Space direction="vertical" size="middle">
        <SpaceBetweenAlignContent>
          <VerticalAlignContent>
            <img src={getBoatTransportLogo()} alt="" />
            <StyledText color="primary" strong>
              {selectedBoat.BusType}
              {' '}
              (
              {selectedBoat.numberOfSeats}
              )
            </StyledText>
          </VerticalAlignContent>

          <StyledTitle level={3}>
            15609
          </StyledTitle>
        </SpaceBetweenAlignContent>

        <WaterTripSummary showChangeButton={false} returning={returning} itinerary />
      </Space>

      <DetailsWrapper>
        <HighlightDetailItem>
          <SpaceBetweenAlignContent>
            <StyledText size="small">
              {moment(selectedBoat.EstimatedDepartureDate).format('hh:mm a')}
            </StyledText>
            <StyledText size="small" strong>
              {moment(selectedBoat.EstimatedArrivalDate).format('hh:mm a')}
            </StyledText>
          </SpaceBetweenAlignContent>
        </HighlightDetailItem>

        <VerticalAlignContent>
          {selectedResult.Stops !== 0 && (
          <StyledText size="small">
            {pluralizeText(selectedResult.Stops, t(translations).stop, t(translations).stops)}
          </StyledText>
          ) }

          <VerticalAlignContent>
            <ClockIcon />
            <StyledText size="small">
              {selectedBoat.Duration}
            </StyledText>
          </VerticalAlignContent>
        </VerticalAlignContent>
      </DetailsWrapper>
    </>
  ) : (<div>&nbsp;</div>));

  return (
    <Space direction="vertical" size="middle">
      <Card size="default">
        <TitleWrapper>
          <StyledParagraph strong color="secondary">
            {t(translations).departure}
          </StyledParagraph>
        </TitleWrapper>
        {
          selectedResult && renderTripDetails()
        }
      </Card>

      {/* Return Info not ready yet  */}
      {
        !oneWayTrip && selectedBoat && (
        <Card size="default">
          <TitleWrapper>
            <StyledParagraph strong color="secondary">
              {t(translations).return}
            </StyledParagraph>
          </TitleWrapper>

          {
            selectedBoat && renderTripDetails(
              true,
            )
          }
        </Card>
        )
      }

      {
        selectedBoat && (
        <Card size="default">
          <TitleWrapper>
            <StyledParagraph strong color="secondary">
              {t(translations).billingBreakdown}
            </StyledParagraph>
          </TitleWrapper>

          {/* TODO Differentiate departure and return fee */}
          <BillingDetailsWrapper>
            <Space direction="vertical" style={{ width: '100%' }}>
              <SpaceBetweenAlignContent>
                <StyledText size="small" color="secondary">
                  {t(translations).departureFare}
                </StyledText>
                <StyledText strong>
                  {formatNumberAsCurrency(totalFare.ticketAmount, selectedBoat.Currency)}
                </StyledText>
              </SpaceBetweenAlignContent>

              {!oneWayTrip && (
              <SpaceBetweenAlignContent>
                <StyledText size="small" color="secondary">
                  {t(translations).returnFare}
                </StyledText>
                <StyledText strong>
                  {formatNumberAsCurrency(totalFare.ticketAmount, selectedBoat.Currency)}
                </StyledText>
              </SpaceBetweenAlignContent>
              )}

              <SpaceBetweenAlignContent>
                <StyledText size="small" color="secondary">
                  {t(translations).serviceFee}
                </StyledText>
                <StyledText strong>
                  {formatNumberAsCurrency(totalFare.totalCharges, selectedBoat.Currency)}
                </StyledText>
              </SpaceBetweenAlignContent>
            </Space>
          </BillingDetailsWrapper>

          <HighlightDetailItem>
            <SpaceBetweenAlignContent>
              <StyledText size="small" color="secondary">
                {t(translations).totalAmount}
              </StyledText>
              <StyledText strong>
                {formatNumberAsCurrency(totalFare.totalAmount, selectedBoat.Currency)}
              </StyledText>
            </SpaceBetweenAlignContent>
          </HighlightDetailItem>
          { showSubmitButton && (
            <Button type="primary" htmlType="submit" block>
              {t(translations).book}
            </Button>
          )}

        </Card>
        )
      }

    </Space>
  );
}

BoatItinerary.defaultProps = {
  showSubmitButton: true,
};
export default BoatItinerary;
